import { BrandMark } from '../../ui/BrandMark';
import s from './auth.module.css';

/** Brand pattern of lines and rounded squares (brand book §1.9), login and empty states only. */
export function Pattern() {
  return (
    <svg className={s.pattern} viewBox="0 0 390 844" preserveAspectRatio="xMidYMid slice" fill="none" aria-hidden="true">
      <g stroke="currentColor" strokeWidth="1.2" strokeLinecap="round">
        <rect x="190" y="-40" width="230" height="200" rx="34" transform="rotate(18 305 60)" />
        <rect x="-70" y="560" width="210" height="190" rx="32" transform="rotate(-14 35 655)" />
        <path d="M120 -10L420 250M-20 470L240 844M260 520L420 470" />
      </g>
      <g stroke="currentColor" strokeWidth="1.2" strokeDasharray="2 5">
        <rect x="250" y="120" width="180" height="170" rx="30" transform="rotate(-22 340 205)" />
        <rect x="210" y="600" width="200" height="180" rx="30" transform="rotate(12 310 690)" />
      </g>
    </svg>
  );
}

const PhoneIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M6 3h3l2 5-2.5 1.5a11 11 0 0 0 6 6L16 13l5 2v3a2 2 0 0 1-2 2A16 16 0 0 1 4 5a2 2 0 0 1 2-2z" />
  </svg>
);

export function SplashScreen() {
  return (
    <main className={s.splash} aria-busy="true" aria-label="Входим">
      <span className={s.pulse}>
        <BrandMark />
      </span>
    </main>
  );
}

interface PhoneProps {
  messenger: string;
  busy: boolean;
  error?: string;
  onShare: () => void;
  onSupport: () => void;
}

export function PhoneScreen({ messenger, busy, error, onShare, onSupport }: PhoneProps) {
  return (
    <main className={s.screen}>
      <Pattern />
      <BrandMark />
      <h1 className={s.title}>Пропуск для гостя — за два касания</h1>
      <p className={s.lead}>Войдите по номеру телефона из {messenger}. Пароль и SMS не нужны.</p>
      <ol className={s.steps}>
        <li className={s.step}><span className={s.stepNo}>1</span>Поделитесь номером в один тап</li>
        <li className={s.step}><span className={s.stepNo}>2</span>Мы найдём вас среди жителей посёлка</li>
        <li className={s.step}><span className={s.stepNo}>3</span>Дальше вход — автоматически</li>
      </ol>
      <div className={s.spacer} />
      <div className={s.actions}>
        {error && (
          <p className={s.error} role="alert">
            <svg className={s.errorIcon} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
              <circle cx="12" cy="12" r="9" />
              <path d="M12 7.5v5.5M12 16.5v.01" />
            </svg>
            {error}
          </p>
        )}
        <button type="button" className={s.primary} onClick={onShare} disabled={busy}>
          <PhoneIcon />
          {busy ? 'Проверяем номер…' : `Войти по номеру из ${messenger}`}
        </button>
        <p className={s.note}>Мы получим только номер телефона — чтобы найти вас среди жителей посёлка.</p>
        <button type="button" className={s.link} onClick={onSupport}>
          Не получается войти? Техподдержка
        </button>
      </div>
    </main>
  );
}

interface MessageProps {
  title: string;
  text: string;
  onRetry?: () => void;
  onSupport?: () => void;
}

export function MessageScreen({ title, text, onRetry, onSupport }: MessageProps) {
  return (
    <main className={s.screen}>
      <Pattern />
      <BrandMark />
      <h1 className={s.title}>{title}</h1>
      <p className={s.lead}>{text}</p>
      <div className={s.spacer} />
      <div className={s.actions}>
        {onRetry && (
          <button type="button" className={s.primary} onClick={onRetry}>
            Повторить
          </button>
        )}
        {onSupport && (
          <button type="button" className={s.link} onClick={onSupport}>
            Техподдержка
          </button>
        )}
      </div>
    </main>
  );
}
